<template>
    <rkm-row>
        <rkm-col cols="12">

            <rkm-area
                class="mb-2"
                type="fieldset"
                title="HORÁRIOS DISPONÍVEIS"
            >
                <rkm-form-radio-group
                    v-model="hora"
                    name="horario"
                    :options="horariosDisponiveis"
                    @change="handleCadastroExame(exames, hora)"
                    :validations="validations.hora"
                />
            </rkm-area>

            <rkm-area
                class="mb-2"
                type="fieldset"
                title="EXAMES SOLICITADOS"
            >
                <rkm-form ref="RkmForm">
                    <rkm-row class="flex-nowrap">
                        <rkm-col class="flex-grow-1">
                            <rkm-form-input-autocomplete
                                :request-query-string-params="autocompletesRequestParams.exame.queryString"
                                :repository="repositories.exame"
                                :searchFields="fields.autocompletes.exame"
                                :text-field="(item) =>  item.codigo ? `${item.codigo} - ${item.nome}` : item.nome"
                                :validations="validations.exame"
                                label="Exame"
                                v-model="exame"
                                :disabled="!hora"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-0 text-nowrap">
                            <rkm-button
                                :label="false"
                                color="primary"
                                @click.stop="addExames()"
                                @handleCadastroExame="handleCadastroExame"
                                :disabled="!hora"
                            >
                                Incluir
                            </rkm-button>

                            <rkm-button
                                :label="false"
                                color="danger"
                                @click.stop="resetForm"
                                :disabled="!hora"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </rkm-form>

                <List
                   :exames="exames"
                   @handleCadastroExame="handleCadastroExame"
                   @deleteExame="deleteExame"
                />

                <ModalPermissao
                    ref="RkmModalPermissao"
                    @saveModal="saveModal"
                    :origem="origem"
                />
            </rkm-area>
        </rkm-col>
    </rkm-row>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, object } from '@/mixins'

// Moment.
import moment from 'moment'

//Enums
import sexo from '@/enums/cadastro/cidadao/sexo'
import tipoSexo from '@/enums/exame-imagem/tipoSexo'
import tipoJornada from '@/enums/exame-imagem/tipoJornada'
import tipoControleJornada from '@/enums/exame-imagem/tipoControleJornada'
import tipoCota from '@/enums/exame-imagem/tipoCota'
import statusPedido from '@/enums/exame-imagem/fechamento/status'

// Components.
import List from '@/components/exame-imagem/agendamento/tabs/cadastro/components/exames/List'
import ModalPermissao from '@/components/exame-imagem/agendamento/tabs/cadastro/components/permissao/Modal'

export default {
    components: { List, ModalPermissao },
    computed: {
        validations() {
            return {
                grupoExameId: { required: true },
                hora: { required: true},
                exame: { required: true}
            }
        },
        autocompletesRequestParams() {

            return {
                exame: {
                    queryString: { grupo_id: this.agendamento.grupoExameId }
                }
            }
        },
        fields() {

            return {
                autocompletes: {
                    exame: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true }
                    ],
                }
            }
        },
        horariosDisponiveis(){

            let horarios = []

            this.jornadas.filter(item => item.data === this.itemSelecionado.data
                && item.profissionalId == this.itemSelecionado.profissionalId
                && item.unidadeId == this.itemSelecionado.unidadeId
                && item.exameId === this.agendamento.grupoExameId)
                .map(horario => {

                    if(horario.controleJornadaId == this.enums.tipoControleJornada.ATENDIMENTO){

                        if(horario.tipoId == this.enums.tipoJornada.DINAMICA){

                            let vagasAtendimentos = 1

                            let vagas = Number(horario.vagas || 0) + Number(horario.vagasApp || 0)

                            let horarioInicial = horario.horaInicial

                            let tempoAtendimento = horario.tempoAtendimento

                            horarioInicial = moment(horarioInicial, "HH:mm")
                                .subtract(tempoAtendimento, 'minutes')
                                .format('HH:mm');

                            for (let i = 0; i < vagas; i++) {

                                if (i !== this.tabIndex) {

                                    horarioInicial = moment(horarioInicial, "HH:mm")
                                        .add(tempoAtendimento, 'minutes')
                                        .format('HH:mm');

                                    let vagasPreenchidas = 0

                                    this.vagas.filter(item => item.horaExame === horarioInicial && item.data === horario.data).map(exameIncluido => {

                                        if(exameIncluido.incluido.length > 0){

                                            vagasPreenchidas = vagasPreenchidas + 1
                                        }
                                    })

                                    let selecionado = this.horarioSelecionado.filter(h => h.horaInicial == horarioInicial).length == 0

                                    if (selecionado || this.horarioAgendamento == horarioInicial || this.agendamento.supervisorId) {

                                        horarios.push({text: horarioInicial + ' - ' + vagasPreenchidas + '/' + vagasAtendimentos, value: horarioInicial})
                                    }
                                }
                            }

                        } else {

                            let vagasPreenchidas = 0

                            let vagasAtendimentos = Number(horario.vagas || 0) + Number(horario.vagasApp || 0)

                            this.vagas.filter(item => {

                                if(item.horaExame === horario.horaInicial && item.data === horario.data){

                                    vagasPreenchidas = vagasPreenchidas + 1
                                }
                            })

                            let horarioInicial = horario.horaInicial

                            let selecionado = this.horarioSelecionado.filter(h => h.horaInicial == horarioInicial).length == 0

                            if (selecionado || this.horaSave == horarioInicial || this.agendamento.supervisorId) {

                                horarios.push({text: horarioInicial + ' - ' + vagasPreenchidas + '/' + vagasAtendimentos, value: horarioInicial})
                            }
                        }

                    } else {

                        if(horario.tipoId == this.enums.tipoJornada.DINAMICA){

                            let vagasAtendimentos = 1

                            let vagas = Number(horario.vagas || 0) + Number(horario.vagasApp || 0)

                            let horarioInicial = horario.horaInicial

                            let tempoAtendimento = horario.tempoAtendimento

                            horarioInicial = moment(horarioInicial, "HH:mm")
                                .subtract(tempoAtendimento, 'minutes')
                                .format('HH:mm');

                            for (let i = 0; i < vagas; i++) {

                                if (i !== this.tabIndex) {

                                    horarioInicial = moment(horarioInicial, "HH:mm")
                                        .add(tempoAtendimento, 'minutes')
                                        .format('HH:mm');

                                    let vagasPreenchidas = 0

                                    this.vagas.filter(item => item.horaExame === horarioInicial && item.data === horario.data).map(exameIncluido => {

                                        if(exameIncluido.incluido.length > 0){

                                            vagasPreenchidas = vagasPreenchidas + 1
                                        }
                                    })

                                    let selecionado = this.horarioSelecionado.filter(h => h.horaInicial == horarioInicial).length == 0

                                    if (selecionado || this.horarioAgendamento == horarioInicial || this.agendamento.supervisorId) {

                                        horarios.push({text: horarioInicial + ' - ' + vagasPreenchidas + '/' + vagasAtendimentos, value: horarioInicial})
                                    }
                                }
                            }
                        } else {

                            let vagasPreenchidas = 0

                            let vagasExames = Number(horario.vagas || 0) + Number(horario.vagasApp || 0)

                            this.vagas.filter(item => item.horaExame === horario.horaInicial && item.data === horario.data).map(exameIncluido => {

                                vagasPreenchidas = vagasPreenchidas + exameIncluido.incluido.length
                            })

                            let horarioInicial = horario.horaInicial

                            let selecionado = this.horarioSelecionado.filter(h => h.horaInicial == horarioInicial).length == 0

                            if (selecionado || this.horaSave == horarioInicial || this.agendamento.supervisorId) {

                                horarios.push(horarioInicial + ' - ' + vagasPreenchidas + '/' + vagasExames)
                            }
                        }
                    }
                })

            this.$emit('horariosDisponiveis', horarios)

            return horarios
        },
    },
    created() {
        this.repositories = {
            feriado: this.getConectaSusRepository('cadastro.feriado.feriado'),
            exame: this.getConectaSusRepository('parametrizacao.exame'),
            periodo: this.getConectaSusRepository('exameImagem.agendamentoRetroativo'),
        },
        this.load()
    },
    data: () => ({
        autoriza: false,
        origem: 'exame',
        verificaExame: false,
        verificaVagas: false,
        verificaCotas: false,
        verificaCotasDinamicas: false,
        verificaCotasExamesDinamicas: false,
        verificaValor: false,
        verificaValorCotas: false,
        verificaDinamica: false,
        verificaFixa: false,
        verificaCotaQuantidade: false,
        desabilitaConfirma: false,
        dataInformada: '',
        checked: false,
        exame: null,
        exames:[],
        horarioSelecionado: [],
        selecionado:{},
        newIndex: null,
        cadastro:[],
        enums: {
            sexo,
            tipoJornada,
            tipoControleJornada,
            tipoSexo,
            tipoCota,
            statusPedido
        },
        hora: null,
        jornada: null,
        trocaCor: true,
        existeData: false,
        cotas: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.agendamento.incluido.length > 0) {

                this.agendamento.incluido.forEach(exame => {

                    this.exames.push(exame)
                })
            }

            if (this.agendamento.horaExame) {

                this.hora = this.agendamento.horaExame
            }

            this.horarioSelecionado = this.vagas.filter(h => h.data == this.itemSelecionado.data)
        },
        handleAdd(exame = null) {

            this.$refs.RkmForm.validate().then(valid => {

                if (!valid) return

                this.supervisorId = null

                if(this.hasExameParametrizadoId(exame.id)){
                    this.resetForm()
                    this.showAlert('Exame já cadastrado no agendamento.', 'Atenção')
                    return
                }

                this.$nextTick().then(() => this.addExames(exame))
            })
        },
        addExames(exame) {
            if (exame) {
                this.exame = exame
            }

            this.setLoading()

            Promise.all([
                this.repositories.periodo.hasSolicitacaoRegulacao({
                    paciente_id: this.data.form.paciente.id,
                    exame_id: this.exame.id
                })
            ]).then(([
                { data: solicitacoesRegulacao }
            ]) => {
                this.addExamesAfterRequests({
                    solicitacoesRegulacao
                })
            }).catch(this.handleError).finally(() => this.unsetLoading())
        },
        addExamesAfterRequests(params) {

            let salvaHora = this.hora.split(" - ")

            const paciente = this.clone(this.data.form.paciente.cidadao.sexo.id)

            const sexoExame = this.exame.sexo
            const sexoExameSemProcedimento = this.exame.sexoId

            this.verificaExame = false

            let msgExame = ''
            let msgRegulacaoSolicitacao = ''

            this.data.model.agendamentos.filter(e => e.pacienteId == this.data.form.paciente.id &&
                e.agendamentoId !== this.agendamento.agendamentoId)
                    .forEach(exameIncluido => {

                        if (this.exame && !this.exame.permiteRepeticao) {

                            let exameFind = exameIncluido.incluido.find(m => m.exameId == this.exame.id);

                            if(exameFind){

                                if (this.exame.validade !== null) {

                                    let addDay = moment(exameIncluido.data).add(this.exame.validade, 'days').format('YYYY-MM-DD')

                                    if  (moment(addDay).isAfter(this.itemSelecionado.data.split("/").reverse().join("-"))) {

                                        if (this.autoriza == false) {

                                            this.dataInformada = exameIncluido.data.split("-").reverse().join("/")
                                            this.horaInicial = exameIncluido.horaExame.split("-").reverse().join("/")

                                            if (msgExame) {

                                                msgExame = msgExame.concat(`, <strong>${ this.dataInformada }</strong>
                                                    às <strong>${this.horaInicial}</strong>`)
                                            } else {

                                                msgExame = msgExame.concat(`O paciente já possui agendamento para o
                                                    exame <strong>${ this.exame.nome}</strong> dentro do prazo de
                                                    validade, na(s) seguinte(s) data(s):
                                                    <strong>${ this.dataInformada }</strong> às
                                                    <strong>${this.horaInicial}</strong>`)
                                            }

                                            this.verificaExame = true
                                        } else {

                                            this.supervisorId = this.agendamento.supervisorId
                                        }
                                    }
                                }
                            }
                        }
                    })

                if(!sexoExame){

                    if(sexoExameSemProcedimento == this.enums.sexo.MASCULINO && this.data.form.paciente.cidadao.sexo.id == this.enums.sexo.FEMININO){

                        this.showValidationNotification('Exame disponível apenas para o sexo masculino.')
                        return false
                    }

                    if(sexoExameSemProcedimento == this.enums.sexo.FEMININO && this.data.form.paciente.cidadao.sexo.id == this.enums.sexo.MASCULINO){

                        this.resetForm()

                        this.showValidationNotification('Exame disponível apenas para o sexo feminino.')

                        return false
                    }
                }

                if(sexoExame == this.enums.tipoSexo.FEMININO
                    && this.data.form.paciente.cidadao.sexo.id == this.enums.sexo.MASCULINO){

                        this.showValidationNotification('Exame disponível apenas para o sexo feminino.')
                }

                if (params.solicitacoesRegulacao.length > 0) {
                    if (this.autoriza == false) {
                        this.verificaExame = true
                        msgRegulacaoSolicitacao = `O paciente possui solicitação(ões) pendente(s) na regulação para
                            este mesmo exame na(s) seguinte(s) data(s): <strong>${params.solicitacoesRegulacao.map(s => s.data).join(', ')}</strong>`
                    }
                    else {
                        this.supervisorId = this.agendamento.supervisorId
                    }
                }

                if (this.verificaExame) {

                    if (msgExame) {

                        msgExame = msgExame.concat(`.<br><br>`)
                    }

                    if (msgRegulacaoSolicitacao) {

                        msgRegulacaoSolicitacao = msgRegulacaoSolicitacao.concat(`.<br><br>`)
                    }

                    const confirm = async () => {

                        this.$refs.RkmModalPermissao.open()

                        return false
                    }

                    const cancel = async () => { this.$emit('handleExit') }

                    const msg = `${msgExame}${msgRegulacaoSolicitacao} Para continuar é necessário informar os dados do
                        supervisor. Deseja continuar?`

                    this.showConfirmation(msg, confirm, cancel)

                } else {

                    if(this.hasExameParametrizadoId(this.exame.id)){
                        this.resetForm()
                        this.showAlert('Exame já cadastrado no agendamento.', 'Atenção')
                        return
                    }

                    const param = {
                        id: this.uniqueId('exame' + new Date().getTime()),
                        exameId: this.exame.id,
                        codigo: this.exame.codigo,
                        nome: this.exame.nome,
                        sexo: sexoExame,
                        sexoPaciente: paciente.sexoId,
                        observacao: this.exame.observacao,
                        valor: this.exame.valorSigtap === 1
                            ? this.exame.valorServicoAmbilatorial
                            : (this.exame.valor && this.exame.valor > 0
                                ? this.exame.valor
                                : this.exame.valorServicoAmbilatorial),
                    }

                    if (this.newIndex !== null) {

                        this.$set(this.exames, this.newIndex, this.clone(param))

                    } else {

                        if(this.itemSelecionado.controleJornadaId == this.enums.tipoControleJornada.EXAME){

                            this.jornadas.filter(item => item.data == this.itemSelecionado.data
                                && item.horaInicial <= salvaHora[0] && item.horaFim >= salvaHora[0]
                                && item.profissionalId == this.itemSelecionado.profissionalId)
                                    .map(verificaTipoExame =>{

                                        if(verificaTipoExame.tipoId == this.enums.tipoJornada.DINAMICA){

                                            // Com cota parametrizada - Jornada Dinamica
                                            this.data.form.cotasPrestadores.filter(item => {

                                                const periodoInicial = moment(item.periodo.start, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                                const periodoFinal = moment(item.periodo.end, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                                const dataAgendamento = moment(verificaTipoExame.data, 'DD/MM/YYYY').format('YYYY-MM-DD');

                                                if ((dataAgendamento >= periodoInicial && dataAgendamento <= periodoFinal)){

                                                    if(item.unidadeId == this.itemSelecionado.unidadeId){

                                                        this.verificaCotasExamesDinamicas = true
                                                        this.cotas = item
                                                    }
                                                }
                                            })

                                            if(this.verificaCotasExamesDinamicas){

                                            // Com cota prestador e do tipo VALOR para jornada Dinamica
                                                if (this.cotas.cotaTipoId == this.enums.tipoCota.VALOR) {

                                                    let valorTotalExames = this.exames
                                                        .filter(exame => exame.valor)
                                                        .reduce((total, exame) => {
                                                            return total + (parseFloat(exame.valor.replace(',', '.')) || 0);
                                                        }, 0);

                                                    let valorTotalVagas = 0;
                                                        this.vagas.forEach(vaga => {
                                                            if (vaga.incluido) {
                                                                vaga.incluido.forEach(v => {
                                                                    valorTotalVagas += Math.round(parseFloat(v.valor.replace(',', '.')) * 100) / 100;
                                                                });
                                                            }
                                                        });

                                                    let valorTotal = valorTotalExames + valorTotalVagas;

                                                    const cotaParametrizada = parseFloat(this.cotas.cotaValor) || 0;

                                                    const valorNovoExame = parseFloat(param.valor.replace(',', '.')) || 0;

                                                    if ((valorTotal + valorNovoExame) <= cotaParametrizada) {

                                                        this.exames = [];
                                                        this.exames.push(this.clone(param));
                                                        this.handleCadastroExame(this.exames, salvaHora[0], this.autoriza, this.jornada);
                                                        this.resetForm();
                                                    } else {

                                                        this.showValidationNotification(`Não foi possível adicionar o exame, pois o limite de cota no valor de
                                                            <strong>R$ ${this.cotas.cotaValor}</strong> para o período
                                                            de <strong>${this.cotas.periodo.start}</strong> até <strong>${this.cotas.periodo.end}</strong> destinada ao prestador da
                                                            unidade <strong>${verificaTipoExame.unidadeNome}</strong> foi atingido, para continuar é necessário alterar o valor da
                                                            cota em <strong>Exame Imagem > Parametrização</strong>.`);
                                                        return false;
                                                    }
                                                } else {

                                                // Com cota prestador e do tipo QUANTIDADE para jornada Dinamica
                                                    const contarExamesIncluidos = () => {
                                                        let totalExamesIncluidos = 0;

                                                        this.vagas.forEach(vaga => {
                                                            if (vaga.incluido && vaga.incluido.length > 0) {
                                                                totalExamesIncluidos += vaga.incluido.length;
                                                            }
                                                        });

                                                        return totalExamesIncluidos;
                                                    };

                                                    let totalExamesIncluidos = contarExamesIncluidos();
                                                    let numeroDeExamesIncluidos = this.exames.length;
                                                    let cotaQuantidade = this.cotas.cotaUnidade;

                                                    if (numeroDeExamesIncluidos < 1) {

                                                        let quantidadeVagas = cotaQuantidade - totalExamesIncluidos;

                                                        if (quantidadeVagas > 0 && numeroDeExamesIncluidos + 1 <= cotaQuantidade) {

                                                            this.exames.push(this.clone(param));
                                                            this.handleCadastroExame(this.exames, salvaHora[0], this.autoriza, this.jornada);

                                                            this.resetForm();

                                                        } else {

                                                            this.resetForm();
                                                            this.showValidationNotification(`Não foi possível adicionar esse exame, pois o limite de cotas destinadas ao prestador da unidade <strong>${verificaTipoExame.unidadeNome}</strong> foi atingido para o período de <strong>${this.cotas.periodo.start}</strong> até <strong>${this.cotas.periodo.end}</strong>. Para continuar, é necessário alterar a quantidade da cota em <strong>Exame Imagem > Parametrização</strong>.`);
                                                            return false;
                                                        }

                                                    } else {

                                                        this.resetForm();
                                                        this.showValidationNotification(`Você só pode adicionar `+
                                                            `um exame por vez para cada horário, pois a jornada ` +
                                                            `selecionada do profissional executante é dinâmica e ` +
                                                            `permite o cadastro de apenas um exame por horário.`);
                                                        return false;
                                                    }
                                                }
                                            } else {

                                                let vagasPreenchidas = 0;

                                                this.vagas
                                                    .filter(item => item.data === this.itemSelecionado.data && item.horaExame === salvaHora[0])
                                                    .forEach(dinamica => {
                                                        vagasPreenchidas += dinamica.incluido.length;
                                                    });

                                                const vagas = 1;
                                                vagasPreenchidas += this.exames.length;

                                                const vagasDisponiveis = vagas - vagasPreenchidas;

                                                if (vagasDisponiveis <= 0 && !this.autoriza && !this.checkAuthorization) {
                                                    this.verificaFixa = true;

                                                    const confirmar = async () => {
                                                        this.$refs.RkmModalPermissao.open();
                                                        this.verificaFixa = false;
                                                        return false;
                                                    };

                                                    const cancelar = async () => {
                                                        this.resetForm();
                                                        this.verificaFixa = false;
                                                    };

                                                    const mensagem = `Você só pode adicionar um exame por vez para` +
                                                    ` cada horário, pois a jornada selecionada do profissional` +
                                                    ` executante é dinâmica e permite o cadastro de apenas um ` +
                                                    ` exame por horário, para continuar é necessário informar os` +
                                                    ` dados do supervisor. Deseja continuar?`;

                                                    this.showConfirmation(mensagem, confirmar, cancelar);
                                                    return false;
                                                } else {
                                                    this.resetForm();

                                                    if (!this.verificaFixa) {
                                                        this.exames.push(this.clone(param));
                                                        this.handleCadastroExame(this.exames, salvaHora[0], this.autoriza, this.jornada);
                                                    }
                                                }
                                            }

                                        } else {

                                            // Com cota parametrizada - Jornada Fixa
                                            this.data.form.cotasPrestadores.filter(item => {

                                                const periodoInicial = moment(item.periodo.start, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                                const periodoFinal = moment(item.periodo.end, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                                const dataAgendamento = moment(verificaTipoExame.data, 'DD/MM/YYYY').format('YYYY-MM-DD');

                                                if ((dataAgendamento >= periodoInicial && dataAgendamento <= periodoFinal)){

                                                    if(item.unidadeId == this.itemSelecionado.unidadeId){

                                                        this.verificaCotasExamesFixas = true
                                                        this.cotas = item
                                                    }
                                                }
                                            })

                                            if(this.verificaCotasExamesFixas){

                                                // Com cota prestador e do tipo VALOR para jornada fixa
                                                if (this.cotas.cotaTipoId == this.enums.tipoCota.VALOR) {

                                                    const dataAgendamento = moment(verificaTipoExame.data, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                                    const mesAgendamento = moment(dataAgendamento).format('MM');
                                                    const anoAgendamento = moment(dataAgendamento).format('YYYY');


                                                    this.exames.push(this.clone(param));
                                                    this.handleCadastroExame(this.exames, salvaHora[0], this.autoriza, this.jornada);
                                                    this.resetForm();

                                                    let valorTotalExames = this.exames
                                                        .filter(exame => exame.valor)
                                                        .reduce((total, exame) => {
                                                            return total + (parseFloat(exame.valor.replace(',', '.')) || 0);
                                                        }, 0);

                                                    let valorTotalVagas = 0;

                                                    this.setLoading();

                                                    this.repositories.periodo.getValorUtilizadoPeriodo({
                                                        mes: mesAgendamento,
                                                        ano: anoAgendamento,
                                                        infraestrutura_id: this.itemSelecionado.infraestruturaId
                                                    })
                                                    .then(response => {

                                                        valorTotalVagas = parseFloat(response.data.valorUtilizadoPeriodo) || 0
                                                    })
                                                    .catch(error => {
                                                        this.handleError(error)
                                                    })
                                                    .finally(() => {

                                                        this.unsetLoading();

                                                        let valorTotal = valorTotalExames + valorTotalVagas;

                                                        const cotaParametrizada = parseFloat(this.cotas.cotaValor) || 0;

                                                        if (valorTotal <= cotaParametrizada) {
                                                            this.handleCadastroExame(this.exames, salvaHora[0], this.autoriza, this.jornada);
                                                            this.resetForm();
                                                        } else {

                                                            this.exames.pop();

                                                            this.resetForm()
                                                            this.showValidationNotification(`Não foi possível adicionar o
                                                                exame, pois o limite de cota no valor de
                                                                <strong>R$ ${this.cotas.cotaValor}</strong> para o período
                                                                de <strong>${this.cotas.periodo.start}</strong> até <strong>
                                                                ${this.cotas.periodo.end}</strong> destinada ao prestador da
                                                                unidade <strong>${verificaTipoExame.unidadeNome}</strong>
                                                                foi atingido, para continuar é necessário alterar o valor da
                                                                cota em <strong>Exame Imagem > Parametrização</strong>.`)
                                                            return false
                                                        }
                                                    })

                                                } else {

                                                // Com cota prestador e do tipo QUANTIDADE para jornada fixa

                                                    let numeroDeExamesIncluidos = this.exames.length;
                                                    let cotaQuantidade =  this.cotas.cotaUnidade

                                                    if (numeroDeExamesIncluidos < cotaQuantidade) {

                                                        this.exames.push(this.clone(param));
                                                        this.handleCadastroExame(this.exames, salvaHora[0], this.autoriza, this.jornada);
                                                        this.resetForm();

                                                    } else {

                                                        this.resetForm()
                                                        this.showValidationNotification(`Não foi possível adicionar esse
                                                            exame, pois o limite de cotas destinadas ao prestador da unidade
                                                            <strong>${verificaTipoExame.unidadeNome}</strong> foi atingida para o período
                                                            de <strong>${this.cotas.periodo.start}</strong> até
                                                            <strong>${this.cotas.periodo.end}</strong>, para
                                                            continuar é necessário alterar a quantidade da cota
                                                            em <strong>Exame Imagem > Parametrização</strong>.`)
                                                        return false
                                                    }
                                                }
                                            } else {

                                                //Se não houver Cota Prestador Parametrizada
                                                let numeroDeExamesIncluidos = this.exames.length;
                                                let vagas = Number(verificaTipoExame.vagas || 0) + Number(verificaTipoExame.vagasApp || 0)

                                                if (numeroDeExamesIncluidos < vagas || this.autoriza == true || this.checkAuthorization == true) {

                                                    this.exames.push(this.clone(param));
                                                    this.handleCadastroExame(this.exames, salvaHora[0], this.autoriza, this.jornada);
                                                    this.resetForm();

                                                } else {

                                                    if(this.autoriza == false && this.checkAuthorization == false){

                                                        const confirm = async () => {

                                                            this.$refs.RkmModalPermissao.open()
                                                            return false
                                                        }

                                                        const cancel = async () => {
                                                            this.resetForm()
                                                        }

                                                        const msg = `A cota de exames foi atingida para o horário das
                                                            <strong>${verificaTipoExame.horaInicial}</strong> do dia <strong>${verificaTipoExame.data}</strong>,
                                                            para continuar é necessário informar os dados do supervisor. Deseja continuar?`

                                                        this.showConfirmation(msg, confirm, cancel)
                                                        return false
                                                    } else {
                                                        this.supervisorId = this.agendamento.supervisorId
                                                    }
                                                }
                                            }
                                        }
                                })
                        }

                        if(this.itemSelecionado.controleJornadaId == this.enums.tipoControleJornada.ATENDIMENTO){

                            this.jornadas.filter(item => item.data == this.itemSelecionado.data
                                && item.unidadeId == this.itemSelecionado.unidadeId
                                && item.exameId === this.agendamento.grupoExameId
                                && item.profissionalId == this.itemSelecionado.profissionalId
                                && item.horaInicial <= salvaHora[0] && item.horaFim >= salvaHora[0]).map(verificaTipo =>{

                                    this.data.form.cotasPrestadores.filter(item => {

                                        const periodoInicial = moment(item.periodo.start, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                            const periodoFinal = moment(item.periodo.end, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                            const dataAgendamento = moment(verificaTipo.data, 'DD/MM/YYYY').format('YYYY-MM-DD');

                                            if ((dataAgendamento >= periodoInicial && dataAgendamento <= periodoFinal)){

                                                if(item.unidadeId == this.itemSelecionado.unidadeId){

                                                    this.verificaCotasAtendimentoFixas = true
                                                    this.cotas = item
                                                }
                                            }
                                    })

                                    if(this.verificaCotasAtendimentoFixas){

                                        if (this.cotas.cotaTipoId == this.enums.tipoCota.VALOR) {

                                                let valorTotalExames = this.exames
                                                    .filter(exame => exame.valor)
                                                    .reduce((total, exame) => {
                                                        return total + (parseFloat(exame.valor.replace(',', '.')) || 0);
                                                    }, 0);

                                                let valorTotalUtilizado = 0;
                                                    this.vagas.forEach(vaga => {
                                                        if (vaga.incluido) {
                                                            vaga.incluido.forEach(v => {
                                                                valorTotalUtilizado += Math.round(parseFloat(v.valor.replace(',', '.')) * 100) / 100;
                                                            });
                                                        }
                                                    });

                                                let valorTotal = valorTotalExames + valorTotalUtilizado;

                                                const cotaParametrizada = parseFloat(this.cotas.cotaValor) || 0;
                                                const cotaRestante = cotaParametrizada - valorTotal;

                                                const valorNovoExame = parseFloat(param.valor.replace(',', '.')) || 0;

                                                if (valorNovoExame > cotaRestante) {

                                                    this.resetForm();
                                                    this.showValidationNotification(`Não foi possível adicionar o exame, pois o limite de cota no valor de
                                                        <strong>R$ ${this.cotas.cotaValor}</strong> para o período de <strong>${this.cotas.periodo.start}</strong>
                                                        até <strong>${this.cotas.periodo.end}</strong> destinada ao prestador da unidade
                                                        <strong>${verificaTipo.unidadeNome}</strong> foi atingido. Para continuar, é necessário alterar o valor da cota em
                                                        <strong>Exame Imagem > Parametrização</strong>.`);
                                                    return false;

                                                } else {

                                                    this.exames.push(this.clone(param));
                                                    this.handleCadastroExame(this.exames, salvaHora[0], this.autoriza, this.jornada);
                                                    this.resetForm();
                                                }

                                        } else {

                                            let numeroDeExamesIncluidos = this.exames.length;
                                            let cotaQuantidade = this.cotas.cotaUnidade;

                                            let exameIncluidoEncontrado = false;

                                            this.vagas.forEach(vaga => {
                                                if (vaga.incluido && !exameIncluidoEncontrado) {
                                                    numeroDeExamesIncluidos += 1;
                                                    exameIncluidoEncontrado = true;
                                                }
                                            });

                                            let saldoDeCota = cotaQuantidade - numeroDeExamesIncluidos;

                                            if (saldoDeCota > 0) {
                                                this.exames.push(this.clone(param));
                                                this.handleCadastroExame(this.exames, salvaHora[0], this.autoriza, this.jornada);
                                                this.resetForm();

                                            } else {
                                                this.resetForm();
                                                this.showValidationNotification(`Não foi possível adicionar o exame, pois o limite de cota da quantidade para o período de <strong>${this.cotas.periodo.start}</strong>
                                                    até <strong>${this.cotas.periodo.end}</strong> destinada ao prestador da unidade
                                                    <strong>${verificaTipo.unidadeNome}</strong> foi atingido. Para continuar, é necessário alterar o valor da cota em
                                                    <strong>Exame Imagem > Parametrização</strong>.`);
                                            }
                                        }
                                    } else {

                                        this.exames.push(this.clone(param));
                                        this.handleCadastroExame(this.exames, salvaHora[0], this.autoriza, this.jornada);
                                        this.resetForm();
                                    }
                                })
                        }
                    }
                }
        },
        saveModal(supervisorId){

            this.agendamento.supervisorId = supervisorId
            this.autoriza = true

            if (this.exame) {

                this.handleAdd(this.exame)
            }

            this.verificaHorario()
        },
        hasExameParametrizadoId(exameParametrizadoId) {

            return this.exames.find(exame => exame.exameId === exameParametrizadoId)
        },
        resetHora(){

            this.hora = null
        },
        deleteExame(item) {

            const objId = this.exames.findIndex((obj =>obj.id == item.id));

            const destroy = async () => {

                this.exames.splice(objId, 1)

                this.resetHora()

                this.$emit('handleCadastro', this.exames)
            }

            this.showDeleteConfirmation(`Deseja realmente excluir o exame <strong>${ item.nome }</strong> da lista?`,
                destroy)
        },
        resetForm() {

            this.exame = null

            this.$nextTick(() => this.$refs.RkmForm.resetValidator())
        },
        handleCadastroExame(){

            let salvaHora = this.hora.split(" - ")

            this.$emit('handleCadastro', this.exames, salvaHora[0], this.autoriza, this.jornada)
        },
        verificaHorario(){

            let salvaHora = this.hora.split(" - ")

            if(this.itemSelecionado.controleJornadaId == this.enums.tipoControleJornada.ATENDIMENTO){

                this.jornadas.filter(item => item.data == this.itemSelecionado.data
                    && item.unidadeId == this.itemSelecionado.unidadeId
                    && item.exameId === this.agendamento.grupoExameId
                    && item.profissionalId == this.itemSelecionado.profissionalId
                    && item.horaInicial <= salvaHora[0] && item.horaFim >= salvaHora[0]).map(verificaTipo => {

                        if(verificaTipo.tipoId == this.enums.tipoJornada.DINAMICA){

                            this.verificaDinamica = false

                            this.vagas.filter(item => item.horaExame === salvaHora[0] && item.data == this.itemSelecionado.data)
                                .map(dinamico => {

                                    this.verificaDinamica = true

                                    if(dinamico && this.autoriza == false && this.checkAuthorization == false){

                                        const confirm = async () => {

                                            this.$refs.RkmModalPermissao.open()

                                            return false
                                        }

                                        const cancel = async () => {

                                            this.resetForm()
                                        }

                                        const msg = `Quantidade de vaga foi atingida para o horário das
                                            <strong>${salvaHora[0]}</strong> do dia <strong>${dinamico.data}</strong>, para continuar é necessário
                                            informar os dados do supervisor. Deseja continuar?`

                                        this.showConfirmation(msg, confirm, cancel)
                                        return false

                                    }  else  {

                                        this.resetForm()
                                    }
                                })

                        } else {

                            this.jornadas.filter(item => item.data == this.itemSelecionado.data
                                && item.horaInicial === salvaHora[0]
                                && item.profissionalId == this.itemSelecionado.profissionalId).map(fixo => {

                                let vagasPreenchidas = 0

                                this.vagas.filter(item => {

                                    if(item.horaExame === salvaHora[0] && item.data === fixo.data){

                                        vagasPreenchidas = vagasPreenchidas + 1
                                    }
                                })

                                let vagas = Number(fixo.vagas || 0) + Number(fixo.vagasApp || 0)

                                const vagasDisponiveis = vagas - vagasPreenchidas

                                if(vagasDisponiveis <= 0 && this.autoriza == false && this.checkAuthorization == false){

                                    this.verificaVagas = false

                                    const confirm = async () => {

                                        this.$refs.RkmModalPermissao.open()
                                        return false
                                    }

                                    const cancel = async () => {

                                        this.resetForm()
                                    }

                                    const msg = `Quantidade de vagas foi atingida para o horário das
                                        <strong>${fixo.horaInicial}</strong> do dia <strong>${fixo.data}</strong>,
                                        para continuar é necessário informar os dados do supervisor. Deseja continuar?`

                                    this.showConfirmation(msg, confirm, cancel)
                                    return false

                                } else  {

                                    this.resetForm()
                                }
                            })
                        }
                    })
            }

            if(this.itemSelecionado.controleJornadaId == this.enums.tipoControleJornada.EXAME){

                this.jornadas.filter(item => item.data == this.itemSelecionado.data
                    && item.unidadeId == this.itemSelecionado.unidadeId
                    && item.exameId === this.agendamento.grupoExameId
                    && item.profissionalId == this.itemSelecionado.profissionalId
                    && item.horaInicial <= salvaHora[0] && item.horaFim >= salvaHora[0]).map(verificaTipoExame => {

                        if(verificaTipoExame.tipoId == this.enums.tipoJornada.DINAMICA){

                            let vagasPreenchidas = 0

                            this.verificaDinamica = false

                            this.vagas.filter(item => item.data == this.itemSelecionado.data && item.horaExame === salvaHora[0])
                                .map(dinamica => {

                                    this.verificaDinamica = true
                                    vagasPreenchidas = vagasPreenchidas + dinamica.incluido.length
                                })

                            if(this.exames.length > 1){

                                this.verificaDinamica = true
                            }

                            vagasPreenchidas = vagasPreenchidas + this.exames.length

                            if(this.verificaDinamica == true && this.autoriza == false && this.checkAuthorization == false){

                                this.verificaVagas = true

                                const confirm = async () => {

                                    this.$refs.RkmModalPermissao.open()
                                    return false
                                }

                                const cancel = async () => {

                                    this.resetForm()
                                }

                                const msg = `Cota de exame foi atingida para o horário das <strong>${salvaHora[0]}</strong>
                                    do dia <strong>${verificaTipoExame.data}</strong>, para continuar é necessário
                                    informar os dados do supervisor. Deseja continuar?`

                                this.showConfirmation(msg, confirm, cancel)
                                return false

                            } else {

                                this.resetForm()
                            }

                        } else {

                            this.jornadas.filter(item => item.data == this.itemSelecionado.data
                                && item.horaInicial == salvaHora[0]
                                && item.profissionalId == this.itemSelecionado.profissionalId).map(fixo => {

                                let vagasPreenchidas = 0

                                this.vagas.filter(item => item.horaExame === salvaHora[0] && item.data === fixo.data)
                                    .map(exameIncluido => {

                                        vagasPreenchidas = vagasPreenchidas + exameIncluido.incluido.length
                                    })

                                const vagas = fixo.vagas

                                vagasPreenchidas = vagasPreenchidas + this.exames.length

                                const vagasDisponiveis = vagas - vagasPreenchidas

                                if(vagasDisponiveis < 0 && this.autoriza == false && this.checkAuthorization == false){

                                    this.verificaVagas = false

                                    const confirm = async () => {

                                        this.$refs.RkmModalPermissao.open()
                                        return false
                                    }

                                    const cancel = async () => {

                                        this.resetForm()
                                    }

                                    const msg = `Cota de exames foi atingida para o horário das
                                        <strong>${fixo.horaInicial}</strong> do dia <strong>${fixo.data}</strong>,
                                        para continuar é necessário informar os dados do supervisor.  Deseja continuar?`

                                    this.showConfirmation(msg, confirm, cancel)
                                    return false

                                } else {

                                    this.resetForm()
                                }
                            })
                        }
                    })
            }
        }
    },
    mixins: [ repository, object ],
    props: {
        data: { type: Object, required: true},
        itemSelecionado: { type: Object, required: true },
        agendamento: { type: Object, required: true },
        vagas: { type: Array, required: true },
        vagasPreenchidas: { type: Number, default: null },
        horaSave: { type: String, default: null },
        checkAuthorization: { type: Boolean, default: false,},
        jornadas: { type: Array, required: true },
    },
}
</script>

